import React, { ReactNode } from "react";
import { motion } from "framer-motion";
import { EASE_OUT } from "../../utils/motion";
type RevealProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
  y?: number;
  x?: number;
};
export function Reveal({
  children,
  className,
  delay = 0,
  y = 24,
  x = 0
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y,
    x
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    margin: "-60px"
  }} transition={{
    duration: 0.3,
    ease: EASE_OUT,
    delay
  }} data-id="element-607" data-mp="ti9lpp405aqf">
      {children}
    </motion.div>;
}